import React, { useState } from 'react';
import { DateTimePicker } from 'components/LegacyPickers';
import jMoment from 'moment-jalaali';
import { DatePickerPod } from 'components';


const FilterDateTime = ({ onFilterChanged, columnDef, ...rest }) => {
  const [selectedDate, setSelectedDate] = useState(jMoment());

  function handleChange(e) {
    setSelectedDate(e);
    onFilterChanged(columnDef.tableData.id, jMoment(e).format('jYYYY/jM/jD HH:mm:ss'));
  }

  return (
    <DatePickerPod>
      <DateTimePicker
        {...rest}
        autoOk
        inputVariant="outlined"
        showTodayButton
        todayLabel="امروز"
        okLabel="تایید"
        cancelLabel="لغو"
        clearLabel="پاک کردن"
        labelFunc={(date) => (date ? date.format('HH:mm:ss jYYYY/jMM/jDD') : '')}
        value={selectedDate}
        onChange={handleChange}
        disableFuture
      />
    </DatePickerPod>
  );
};

export default FilterDateTime;
